import { ExternalLink } from "lucide-react";
import { PARTNER_LINK } from "@/lib/constants";

const PartnerStatusSection = () => (
  <section id="partnerlink-status" className="py-10 md:py-16">
    <div className="container">
      <div className="mx-auto max-w-3xl">
        <h2 className="font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
          Wie du heilys Produkte am besten bestellst
        </h2>
        <div className="mt-4 space-y-3 text-sm leading-relaxed text-muted-foreground md:text-base">
          <p>
            heilys Produkte sind ausschließlich über den offiziellen heilys Shop erhältlich. Dort findest du
            das vollständige Sortiment, aktuelle Produktdetails, Lieferzeiten und die jeweils gültigen
            Konditionen – transparent für alle Kunden gleichermaßen.
          </p>
          <p>
            heilys.info ist eine unabhängige Informationsseite und kein Shop. Wir ordnen die Produkte ein,
            beschreiben Anwendungsbereiche und verlinken für den Kauf direkt zum Hersteller.
          </p>
          <p>
            Wenn du den Partnerlink nutzt, unterstützt du diese unabhängige Informationsseite – ohne
            Mehrkosten für dich.
          </p>
        </div>
        <div className="mt-6">
          <a
            href={PARTNER_LINK}
            target="_blank"
            rel="sponsored noopener noreferrer"
            onClick={() => window.lh?.trackAffiliate({ source: "partner_status" })}
            className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-all hover:brightness-110"
          >
            Zum offiziellen heilys Shop
            <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default PartnerStatusSection;
